import {
	VelocityClient,
	VelocityClientConfig,
	VelocityClientSubscriptionConfig,
	VelocityEnv,
	DelistedMarketSetting,
	Wallet,
	BulkAccountLoader,
	VELOCITY_PROGRAM_ID,
	WebSocketVelocityClientAccountSubscriberV2,
} from '@velocity-exchange/sdk';
import { Connection, PublicKey } from '@solana/web3.js';
import { UIMarket } from '@velocity-exchange/common';
import Env, {
	SubscriberType,
} from 'src/environmentVariables/EnvironmentVariables';
import { DRIFT_CLIENT_OPTS } from 'src/stores/DriftStore/constants';

export const generateDriftClient = (
	connection: Connection,
	accountLoader: BulkAccountLoader,
	wallet: Wallet,
	env: VelocityEnv,
	subscriberType?: SubscriberType
) => {
	// TEMP: disabled websocket sub while we investigate memory/leaking connections issues
	// Cast required after velocity migration —
	// `WebSocketVelocityClientAccountSubscriberV2` now ships a wider ctor
	// signature than the union expected by `VelocityClientSubscriptionConfig`.
	const wsAccountSubscription: VelocityClientSubscriptionConfig = {
		type: 'websocket',
		velocityClientAccountSubscriber:
			WebSocketVelocityClientAccountSubscriberV2 as any,
		logResubMessages: false,
		resubTimeoutMs: 30_000,
	};

	const accountSubscription: VelocityClientSubscriptionConfig =
		subscriberType === 'websocket'
			? wsAccountSubscription
			: {
					type: 'polling',
					accountLoader: accountLoader,
				};

	const driftClientConfig: VelocityClientConfig = {
		connection: connection,
		wallet,
		programID: new PublicKey(VELOCITY_PROGRAM_ID),
		accountSubscription,
		perpMarketIndexes: UIMarket.perpMarkets.map((m) => m.marketIndex),
		spotMarketIndexes: UIMarket.spotMarkets.map((m) => m.marketIndex),
		oracleInfos: Env.oracleInfos,
		userStats: true,
		includeDelegates: true,
		env,
		// dont waste rpc calls loading users for this made up wallet
		skipLoadUsers: true,
		enableMetricsEvents: true,
		txHandlerConfig: {
			blockhashCachingEnabled: Env.useCachedBlockhashFetcherInDriftClient,
		},
		opts: DRIFT_CLIENT_OPTS,
		delistedMarketSetting: DelistedMarketSetting.Unsubscribe,
	};

	return new VelocityClient(driftClientConfig);
};
